export default __webpack_public_path__ + "static/media/4bfd4d98-9863-4052-a22b-04472982b43a.78338f88.png";